
export const customMonthFilterOperators = [
  {
    label: 'is any of',
    value: 'containsMonth',
    getApplyFilterFn: filterItem => {
      if (!filterItem.value || filterItem.value.length === 0) return null

      const monthsToFilter = filterItem.value

      return rowValue => {
        // rowValue will be the array returned from valueGetter
        if (!Array.isArray(rowValue)) return false
        return monthsToFilter.some(month => rowValue.includes(month))
      }
    },
    InputComponent: undefined, // You already control the Select UI elsewhere
  },
]
